import { GyymClientOptions, GyymApiClient } from '#client/client'

export const createGyymApiClient = (
  options: GyymClientOptions = {},
): GyymApiClient => {
  return new GyymApiClient(options)
}
